import { ColumnDef } from '@/components/operations/types';
import { SalesOrderRow } from './types';

export const SALES_ORDER_COLUMNS: ColumnDef<SalesOrderRow>[] = [
  {
    id: 'status',
    label: 'Status',
    accessor: (r) => r.status,
    sortValue: (r) => r.status,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
    defaultFilter: ['Open', 'Ready'],
  },
  {
    id: 'completedAt',
    label: 'Completed',
    accessor: (r) => r.completedAt,
    sortValue: (r) => r.completedTs,
    numericValue: (r) => r.completedTs,
    totalType: 'count',
    category: 'basic',
    dataType: 'date',
    defaultHidden: true,
  },
  {
    id: 'orderNumber',
    label: 'Sales Order',
    accessor: (r) => r.orderNumber,
    sortValue: (r) => r.orderNumber,
    totalType: 'count',
    category: 'basic',
    dataType: 'string',
  },
  {
    id: 'customer',
    label: 'Customer',
    accessor: (r) => r.customer,
    sortValue: (r) => r.customer,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'location',
    label: 'Location',
    accessor: (r) => r.location,
    sortValue: (r) => r.location,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'date',
    label: 'Date',
    accessor: (r) => r.date,
    sortValue: (r) => r.dateTs,
    totalType: 'count',
    category: 'basic',
    dataType: 'date',
    numericValue: (r) => r.dateTs,
  },
  {
    id: 'workOrdersTotal',
    label: 'Work Orders',
    accessor: (r) => String(r.workOrdersTotal),
    sortValue: (r) => r.workOrdersTotal,
    totalType: 'sum',
    numericValue: (r) => r.workOrdersTotal,
    category: 'related',
    dataType: 'number',
  },
  {
    id: 'workOrdersComplete',
    label: 'WOs Complete',
    accessor: (r) => String(r.workOrdersComplete),
    sortValue: (r) => r.workOrdersComplete,
    totalType: 'sum',
    numericValue: (r) => r.workOrdersComplete,
    category: 'related',
    dataType: 'number',
  },
  {
    id: 'workOrdersPercent',
    label: 'WO % Complete',
    accessor: (r) => `${r.workOrdersPercent}%`,
    sortValue: (r) => r.workOrdersPercent,
    totalType: 'count',
    category: 'related',
    dataType: 'number',
    numericValue: (r) => r.workOrdersPercent,
  },
  {
    id: 'opsTotal',
    label: 'Operations',
    accessor: (r) => String(r.opsTotal),
    sortValue: (r) => r.opsTotal,
    totalType: 'sum',
    numericValue: (r) => r.opsTotal,
    category: 'related',
    dataType: 'number',
  },
  {
    id: 'opsComplete',
    label: 'Ops Complete',
    accessor: (r) => String(r.opsComplete),
    sortValue: (r) => r.opsComplete,
    totalType: 'sum',
    numericValue: (r) => r.opsComplete,
    category: 'related',
    dataType: 'number',
  },
  {
    id: 'opsPercent',
    label: 'Ops % Complete',
    accessor: (r) => `${r.opsPercent}%`,
    sortValue: (r) => r.opsPercent,
    totalType: 'count',
    category: 'related',
    dataType: 'number',
    numericValue: (r) => r.opsPercent,
  },
];
